
export default {
  vessel: {
    menuItem: {
      fontSize: 'sm'
    }
  }
}
